const projectTaskReducer = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default projectTaskReducer;
